
import { Component, Vue, Emit, Model, Watch } from 'vue-property-decorator'

@Component({})
export default class Filters extends Vue {
  options: Array<any> = [
    {
      text: this.$t('filters.byPriceLow'),
      value: 'sale_price',
      sort: 'asc',
    },
    {
      text: this.$t('filters.byPriceHigh'),
      value: 'sale_price',
      sort: 'desc',
    },
    {
      text: this.$t('filters.byNameA'),
      value: 'name',
      sort: 'asc',
    },
    {
      text: this.$t('filters.byNameZ'),
      value: 'name',
      sort: 'desc',
    },
  ]

  @Emit('selected-filter')
  selectedValues(event) {
    event.target.value
  }
}
